import React, { createContext, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const BetaContext = createContext(null);

// Party IDs for each version
const PARTY_ID_V1 = 'oscars_party_2026';
const PARTY_ID_V2_BETA = 'oscars_party_2025';

export const BetaProvider = ({ children }) => {
  const location = useLocation();

  const value = useMemo(() => {
    const isBetaMode = location.pathname.startsWith('/beta');

    return {
      isBetaMode,
      activePartyId: isBetaMode ? PARTY_ID_V2_BETA : PARTY_ID_V1,
      basePath: isBetaMode ? '/beta' : '',
    };
  }, [location.pathname]);

  return (
    <BetaContext.Provider value={value}>
      {children}
    </BetaContext.Provider>
  );
};

export const useBeta = () => {
  const context = useContext(BetaContext);
  if (!context) {
    throw new Error('useBeta must be used within a BetaProvider');
  }
  return context;
};

export default BetaContext;
